import { isValidTimeZone, resolveDisplayTimeZone } from "./live-config";

/** Curated US IANA zones for site scheduling (no free-text typos). */
export const SITE_TIMEZONE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "America/New_York", label: "Eastern (New York)" },
  { value: "America/Detroit", label: "Eastern (Detroit)" },
  { value: "America/Indiana/Indianapolis", label: "Eastern (Indiana)" },
  { value: "America/Kentucky/Louisville", label: "Eastern (Louisville, KY)" },
  { value: "America/Chicago", label: "Central (Chicago)" },
  { value: "America/Denver", label: "Mountain (Denver)" },
  { value: "America/Phoenix", label: "Arizona (no daylight saving)" },
  { value: "America/Los_Angeles", label: "Pacific (Los Angeles)" },
  { value: "America/Anchorage", label: "Alaska" },
  { value: "Pacific/Honolulu", label: "Hawaii" },
  { value: "America/Puerto_Rico", label: "Atlantic (Puerto Rico)" },
  { value: "America/Adak", label: "Aleutian (Adak)" },
];

const KNOWN_VALUES = new Set(SITE_TIMEZONE_OPTIONS.map((option) => option.value));

/** Options for a select, preserving a legacy stored zone when it is valid but not in the list. */
export function siteTimezoneSelectOptions(currentValue: string): Array<{ value: string; label: string }> {
  const normalized = resolveDisplayTimeZone(currentValue);
  if (!KNOWN_VALUES.has(normalized) && isValidTimeZone(normalized)) {
    return [{ value: normalized, label: `${normalized} (saved)` }, ...SITE_TIMEZONE_OPTIONS];
  }
  return [...SITE_TIMEZONE_OPTIONS];
}

export const DEFAULT_SITE_TIMEZONE = resolveDisplayTimeZone(undefined);
